/*
  Bundle & Save placements (Oct 2026), prefix zbs-.
  - window.zbsRender() re-renders every placement from window.zBundleTiers (array of 3 numbers),
    falling back to the group read from cart discounts, then the theme-setting default tiers.
  - Hides everything after zbsConfig.end (checked here so cached pages hide too).
  - PDP "Pairs well" list: /recommendations intent=complementary, then related.
  - Survives the PDP swatch swap: a MutationObserver re-inits any new .zbs-pdp.
*/
(function () {
  'use strict';
  var C = window.zbsConfig || {};
  if (!C.enabled) return;

  var GROUP_KEY = 'zbsTiers';
  var cart = null;          // last /cart.js
  var cartPromise = null;
  var startCount = null;    // item count when this page loaded
  var addedHere = false;    // shopper added something on this page
  var renderQueued = false;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function root() { return (C.root && C.root !== '/') ? C.root.replace(/\/$/, '') + '/' : '/'; }

  function ended() {
    var e = Date.parse(C.end);
    return !!(e && Date.now() > e);
  }

  function validTiers(t) {
    return Array.isArray(t) && t.length === 3 && t.every(function (x) { return isFinite(+x) && +x > 0; });
  }
  function storedGroup() {
    try { var v = JSON.parse(sessionStorage.getItem(GROUP_KEY) || 'null'); return validTiers(v) ? v : null; } catch (e) { return null; }
  }
  // Intelligems: the variation name carries the tiers, e.g. "Group B 20/25/30"
  function igTiers() {
    if (!C.igExperiment) return null;
    try {
      var u = window.igData && window.igData.user;
      if (!u || typeof u.getVariationName !== 'function') return null;
      var m = /(\d+)\s*\/\s*(\d+)\s*\/\s*(\d+)/.exec(u.getVariationName(C.igExperiment) || '');
      return m ? [+m[1], +m[2], +m[3]] : null;
    } catch (e) { return null; }
  }
  function tiers() {
    if (validTiers(window.zBundleTiers)) return window.zBundleTiers.map(Number);
    return igTiers() || storedGroup() || C.tiers || [15, 20, 25];
  }

  /* ---------- money ---------- */
  function money(cents, short) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || C.currency || 'AUD';
    var v = cents / 100;
    var opts = { style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol' };
    if (short) { opts.minimumFractionDigits = v % 1 ? 2 : 0; opts.maximumFractionDigits = 2; }
    var s;
    try { s = new Intl.NumberFormat('en-AU', opts).format(v); } catch (e) { s = '$' + v.toFixed(2); }
    return short ? s : s + ' ' + cur;
  }

  /* ---------- cart ---------- */
  function countItems(c) {
    var n = 0;
    (c && c.items || []).forEach(function (it) {
      if (it.gift_card || it.vendor === "re:do" || (it.properties && it.properties._gift)) return;
      if ((it.original_price || it.price || 0) < 200) return;
      n += it.quantity;
    });
    return n;
  }
  function appliedBundlePct(c) {
    var re = /bundle\s*&(?:amp;)?\s*save\s*(\d+)\s*%/i, best = 0;
    function scan(t) { var m = re.exec(t || ''); if (m) best = Math.max(best, +m[1]); }
    (c && c.cart_level_discount_applications || []).forEach(function (d) { scan(d.title); });
    (c && c.items || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (a) { scan(a.discount_application && a.discount_application.title); });
      (it.discounts || []).forEach(function (d) { scan(d.title); });
    });
    return best;
  }
  function otherDiscount(c) {
    var has = false;
    (c && c.cart_level_discount_applications || []).forEach(function (d) { if (!/bundle/i.test(d.title || '')) has = true; });
    (c && c.items || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (a) {
        var t = a.discount_application && a.discount_application.title;
        if (t && !/bundle/i.test(t) && a.amount > 0) has = true;
      });
    });
    return has;
  }
  function inferGroup(c) {
    if (validTiers(window.zBundleTiers) || igTiers()) return;
    var n = countItems(c), p = appliedBundlePct(c);
    if (n < 2 || !p) return;
    var idx = Math.min(n, 4) - 2;
    var match = (C.groups || []).filter(function (g) { return +g[idx] === p; });
    if (match.length === 1) {
      try { sessionStorage.setItem(GROUP_KEY, JSON.stringify(match[0])); } catch (e) {}
    }
  }
  function loadCart() {
    cartPromise = fetch(root() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var n = countItems(c);
        if (startCount === null) startCount = n;
        else if (cart && n > countItems(cart)) addedHere = true;
        cart = c;
        inferGroup(c);
        queueRender();
        return c;
      })
      .catch(function () { return cart; });
    return cartPromise;
  }
  var cartTimer = null;
  function refreshCartSoon(ms) {
    clearTimeout(cartTimer);
    cartTimer = setTimeout(loadCart, ms == null ? 350 : ms);
  }

  /* ---------- tier text ---------- */
  function fill(tpl, t) { return tpl.replace(/\{(\d)\}/g, function (_, i) { return t[+i]; }); }
  function renderTemplates(t) {
    $$('[data-zbs-tpl]').forEach(function (el) {
      var s = fill(el.getAttribute('data-zbs-tpl'), t);
      if (el.textContent !== s) el.textContent = s;
    });
  }

  /* ---------- cart drawer progress ---------- */
  function renderCartBlocks(t) {
    var blocks = $$('[data-zbs-cart]');
    if (!blocks.length) return;
    blocks.forEach(function (b) {
      // the drawer block is re-rendered server-side on every cart change, so its count is the freshest;
      // only trust the cached /cart.js (for the real applied %) when it agrees with that count
      var serverN = +b.getAttribute('data-zbs-n') || 0;
      var fresh = cart && countItems(cart) === serverN;
      var n = serverN;
      if (n < 1) { b.hidden = true; return; }
      b.hidden = false;
      var tierPct = n >= 4 ? t[2] : n === 3 ? t[1] : n === 2 ? t[0] : 0;
      var real = fresh ? appliedBundlePct(cart) : 0;
      var applied = $('[data-zbs-cart-applied]', b), msg = $('[data-zbs-cart-msg]', b);
      var a = '', m = '';
      if (n >= 2 && fresh && !real && otherDiscount(cart)) {
        a = '';
        m = 'Your discount code is giving a bigger saving, so the bundle saving is not added.';
      } else {
        var shown = real || tierPct;
        a = shown ? shown + '% off applied' : '';
        if (n >= 4) m = "You're getting the top saving, " + (real || t[2]) + '% off everything.';
        else if (n === 3) m = 'Add 1 more item to save ' + t[2] + '%';
        else if (n === 2) m = 'Add 1 more item to save ' + t[1] + '%';
        else m = 'Add 1 more item to save ' + t[0] + '%';
      }
      if (applied && applied.textContent !== a) applied.textContent = a;
      if (msg && msg.textContent !== m) msg.textContent = m;
      $$('[data-zbs-step]', b).forEach(function (s) {
        s.classList.toggle('is-on', n >= +s.getAttribute('data-zbs-step'));
      });
    });
  }

  /* ---------- mobile sticky nudge (PDP) ---------- */
  var nudge = null;
  function ensureNudge() {
    if (nudge || !$('.zbs-pdp')) return nudge;
    nudge = document.createElement('div');
    nudge.className = 'zbs-nudge';
    nudge.setAttribute('data-zbs', '');
    nudge.setAttribute('role', 'status');
    nudge.hidden = true;
    nudge.innerHTML =
      '<div class="zbs-nudge__main"><p class="zbs-nudge__msg"></p>' +
      '<div class="zbs-nudge__bar"><span></span><span></span><span></span><span></span></div></div>' +
      '<button type="button" class="zbs-nudge__btn">View cart</button>';
    nudge.querySelector('.zbs-nudge__btn').addEventListener('click', function () {
      var d = $('cart-drawer');
      if (d && typeof d.open === 'function') d.open(); else location.href = root() + 'cart';
    });
    document.body.appendChild(nudge);
    return nudge;
  }
  function renderNudge(t) {
    if ($('.zbs-pdp--aware')) { if (nudge) nudge.hidden = true; positionNudge(); return; }
    if (!ensureNudge()) return;
    var n = cart ? countItems(cart) : 0;
    if (!addedHere || n < 1) { if (!nudge.hidden) { nudge.hidden = true; positionNudge(); } return; }
    var msg;
    if (n >= 4) msg = "You're getting the top saving, " + t[2] + '% off everything.';
    else if (n === 3) msg = '3 in cart. Add 1 more for ' + t[2] + '% off.';
    else if (n === 2) msg = '2 in cart. Add 1 more for ' + t[1] + '% off.';
    else msg = '1 in cart. Add 1 more for ' + t[0] + '% off both.';
    nudge.querySelector('.zbs-nudge__msg').textContent = msg;
    $$('.zbs-nudge__bar span', nudge).forEach(function (s, i) { s.classList.toggle('is-on', i < Math.min(n, 4)); });
    nudge.hidden = false;
    positionNudge();
  }
  // keep the nudge above the theme's sticky add-to-cart bar, and lift the Alia teaser (or in-house .zp-pill) above the nudge
  function positionNudge() {
    if (!nudge) return;
    var on = !nudge.hidden && getComputedStyle(nudge).display !== 'none';
    var offset = 0;
    if (on) {
      $$('.sticky-atc, .sticky_atc, sticky-add-to-cart, .sticky-add-to-cart').forEach(function (el) {
        var cs = getComputedStyle(el), r = el.getBoundingClientRect();
        if (cs.position === 'fixed' && cs.display !== 'none' && cs.visibility !== 'hidden' && r.height && r.bottom >= window.innerHeight - 2) offset = Math.max(offset, r.height);
      });
      var b = offset + 'px';
      if (nudge.style.bottom !== b) nudge.style.bottom = b;
    }
    var lift = on ? offset + nudge.offsetHeight + 12 : 0;
    $$('[id^="alia-root-"], .zp-pill').forEach(function (el) {
      var cs = getComputedStyle(el);
      if (cs.position !== 'fixed') return;
      if (on && el.offsetHeight > 0 && el.offsetHeight < 200) {
        if (!el.hasAttribute('data-zbs-lift')) el.setAttribute('data-zbs-lift', el.style.bottom || '');
        var v = lift + 'px';
        if (el.style.bottom !== v) el.style.setProperty('bottom', v, 'important');
      } else if (el.hasAttribute('data-zbs-lift')) {
        var orig = el.getAttribute('data-zbs-lift');
        el.removeAttribute('data-zbs-lift');
        if (orig) el.style.bottom = orig; else el.style.removeProperty('bottom');
      }
    });
  }
  var posTimer = null;
  window.addEventListener('scroll', function () {
    if (!nudge || nudge.hidden) return;
    clearTimeout(posTimer);
    posTimer = setTimeout(positionNudge, 80);
  }, { passive: true });

  /* ---------- PDP pairs ---------- */
  function recUrl(pid, intent) {
    return root() + 'recommendations/products.json?product_id=' + encodeURIComponent(pid) + '&limit=10&intent=' + intent;
  }
  function getRecs(pid, intent) {
    return fetch(recUrl(pid, intent), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) { return d.products || []; })
      .catch(function () { return []; });
  }
  function imgUrl(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  function setText(el, text) { if (el && el.textContent !== text) el.textContent = text; }
  function eligiblePair(p, el) {
    if (!p || !p.available || String(p.id) === el.getAttribute('data-zbs-pid')) return false;
    if (p.gift_card || /gift[\s-]?card/i.test((p.product_type || '') + ' ' + (p.handle || '')) || p.vendor === 're:do') return false;
    if ((p.price || 0) < 200) return false;
    var base = (el.getAttribute('data-zbs-base') || '').toLowerCase().trim();
    if (base && (p.title || '').toLowerCase().indexOf(base) === 0) return false;
    return (p.variants || []).some(function (v) { return v.available; });
  }
  function initPdp(el) {
    if (el.__zbsRequested || !el.classList.contains('zbs-pdp--aware')) return;
    el.__zbsRequested = true;
    var pid = el.getAttribute('data-zbs-pid');
    // Keep the saved complementary (sales-based) order. Related only fills unused slots.
    Promise.all([getRecs(pid, 'complementary'), getRecs(pid, 'related')]).then(function (sets) {
      var seen = {}, picked = [];
      sets.forEach(function (products) {
        products.forEach(function (p) {
          if (!seen[p.id] && eligiblePair(p, el)) { seen[p.id] = true; picked.push(p); }
        });
      });
      el.__zbsProducts = picked;
      queueRender();
    }).catch(function () { el.__zbsProducts = []; queueRender(); });
  }
  function renderPairs(el) {
    var inCart = {};
    (cart && cart.items || []).forEach(function (it) { inCart[it.product_id] = true; });
    var items = (el.__zbsProducts || []).filter(function (p) { return !inCart[p.id]; }).slice(0, 2);
    var wrap = $('.zbs-pairs-wrap', el), list = $('[data-zbs-pairs]', el);
    wrap.hidden = !items.length;
    var key = items.map(function (p) { return p.id; }).join(',');
    if (el.__zbsPairKey !== key) {
      el.__zbsPairKey = key;
      list.innerHTML = items.map(function (p, index) {
        var variants = (p.variants || []).filter(function (v) { return v.available; });
        var oneSize = variants.length === 1 && /^(default title|one size|os|o\/s)$/i.test(variants[0].title || '');
        var url = p.url || root() + 'products/' + p.handle;
        var sizeId = list.id + '-' + p.id;
        var sizes = oneSize ? '' : '<div class="zbs-pair__sizes" id="' + sizeId + '" hidden>' + variants.map(function (v) {
          return '<button type="button" class="zbs-chip" data-zbs-vid="' + v.id + '">' + escapeHtml(v.title) + '</button>';
        }).join('') + '</div>';
        return '<div class="zbs-pair" data-zbs-extra="' + (index >= 2 ? 'true' : 'false') + '" data-zbs-vid="' + (oneSize ? variants[0].id : '') + '">' +
          '<a class="zbs-pair__img" href="' + escapeHtml(url) + '"><img src="' + escapeHtml(imgUrl(p.featured_image, 120)) + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="52" height="58"></a>' +
          '<div class="zbs-pair__info"><a class="zbs-pair__name" href="' + escapeHtml(url) + '">' + escapeHtml(p.title) + '</a><span class="zbs-pair__price">' + escapeHtml(money(p.price, true)) + '</span></div>' +
          '<button type="button" class="zbs-add"' + (oneSize ? '' : ' aria-expanded="false" aria-controls="' + sizeId + '"') + ' aria-label="' + (oneSize ? 'Add ' : 'Choose size for ') + escapeHtml(p.title) + '">' + (oneSize ? '+ Add' : 'Choose size') + '</button>' +
          sizes + '<p class="zbs-pair__err" role="alert" hidden></p></div>';
      }).join('');
    }

  }
  function renderPdps(t) {
    $$('.zbs-pdp--aware').forEach(function (el) {
      var n = countItems(cart), actual = appliedBundlePct(cart);
      $('.zbs-pdp__empty', el).hidden = n > 0;
      $('.zbs-pdp__active', el).hidden = n === 0;
      if (!n) return;
      setText($('.zbs-pdp__count', el), n + (n === 1 ? ' item' : ' items') + ' in cart');
      var label, next;
      if (actual) {
        label = actual + '% off applied';
        next = n >= 4 ? "You're getting the top bundle saving." : 'Add 1 more item to save ' + t[n - 1] + '% on your bundle.';
      } else if (n === 1) {
        label = 'Add 1 more item for ' + t[0] + '% off';
        next = 'Mix any eligible clothing and gear.';
      } else {
        label = otherDiscount(cart) ? 'Your existing discount is active' : 'Review your bundle saving in your cart';
        next = 'Your cart shows the discount available for these items.';
      }
      setText($('[data-zbs-status]', el), label);
      setText($('[data-zbs-next]', el), next);
      $('.zbs-pdp__status', el).classList.toggle('is-applied', actual > 0);
      var progress = $('.zbs-pdp__progress', el);
      progress.setAttribute('aria-valuenow', Math.min(n, 4));
      progress.setAttribute('aria-valuetext', n + ' eligible items. ' + label);
      $$('.zbs-pdp__segments span', el).forEach(function (step, i) { step.classList.toggle('is-on', i < Math.min(n, 4)); });
      if (n < 4) { initPdp(el); renderPairs(el); }
      else $('.zbs-pairs-wrap', el).hidden = true;
    });
  }

  function addVariant(row, vid, btn) {
    if (!vid || row.__zbsBusy) return;
    row.__zbsBusy = true;
    row.setAttribute('aria-busy', 'true');
    $$('button', row).forEach(function (b) { b.disabled = true; });
    var err = $('.zbs-pair__err', row);
    if (err) err.hidden = true;
    btn.classList.add('is-busy');
    btn.disabled = true;
    var drawer = $('cart-drawer');
    var secs = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (x) { return x.id; }) : ['cart-drawer', 'cart-icon-bubble'];
    var url = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : root() + 'cart/add') + '.js';
    fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: +vid, quantity: 1, sections: secs, sections_url: location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        row.__zbsBusy = false;
        row.removeAttribute('aria-busy');
        $$('button', row).forEach(function (b) { b.disabled = false; });
        btn.classList.remove('is-busy');
        btn.disabled = false;
        if (res.status) {
          if (err) { err.textContent = res.description || res.message || 'Could not add this item'; err.hidden = false; }
          return;
        }
        addedHere = true;
        $$('.zbs-add', row).forEach(function (b) { b.textContent = 'Added'; b.classList.add('is-done'); });
        var sizes = $('.zbs-pair__sizes', row); if (sizes) sizes.hidden = true;
        if (drawer && drawer.renderContents && res.sections) {
          try { drawer.classList.remove('is-empty'); drawer.renderContents(res); }
          catch (e) { if (typeof window.new_updateCartDrawer === 'function') window.new_updateCartDrawer(); }
        } else if (typeof window.new_updateCartDrawer === 'function') {
          window.new_updateCartDrawer();
        }
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          try { window.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'zbs-bundle', cartData: res }); } catch (e) {}
        }
        refreshCartSoon(300);
      })
      .catch(function () {
        row.__zbsBusy = false;
        row.removeAttribute('aria-busy');
        $$('button', row).forEach(function (b) { b.disabled = false; });
        btn.classList.remove('is-busy'); btn.disabled = false;
        if (err) { err.textContent = 'Could not add this item'; err.hidden = false; }
      });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var view = e.target.closest('.zbs-pdp__view');
    if (view) {
      e.preventDefault();
      var drawer = $('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        if (drawer.setActiveElement) drawer.setActiveElement(view);
        if (cart && cart.item_count) drawer.classList.remove('is-empty');
        drawer.open(view);
      } else location.href = root() + 'cart';
      return;
    }
    var add = e.target.closest('.zbs-pdp .zbs-add');
    if (add) {
      e.preventDefault();
      var row = add.closest('.zbs-pair');
      if (add.classList.contains('is-done')) return;
      var vid = row.getAttribute('data-zbs-vid');
      if (vid) { addVariant(row, vid, add); return; }
      var sizes = $('.zbs-pair__sizes', row);
      if (sizes) {
        var open = sizes.hidden;
        $$('.zbs-pdp .zbs-pair__sizes').forEach(function (s) { s.hidden = true; });
        $$('.zbs-pdp .zbs-add[aria-expanded]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        add.setAttribute('aria-expanded', open ? 'true' : 'false');
        sizes.hidden = !open;
      }
      return;
    }
    var chip = e.target.closest('.zbs-pdp .zbs-chip');
    if (chip) {
      e.preventDefault();
      addVariant(chip.closest('.zbs-pair'), chip.getAttribute('data-zbs-vid'), chip);
    }
  });

  /* ---------- render ---------- */
  function render() {
    renderQueued = false;
    if (ended()) {
      document.documentElement.classList.add('zbs-off');
      if (nudge) nudge.hidden = true;
      return;
    }
    var t = tiers();
    renderTemplates(t);
    renderPdps(t);
    renderCartBlocks(t);
    renderNudge(t);
  }
  function queueRender() {
    if (renderQueued) return;
    renderQueued = true;
    setTimeout(render, 30);
  }
  window.zbsRender = function () { render(); };

  /* ---------- wiring ---------- */
  function boot() {
    loadCart();
    render();

    // theme cart events (product form, quick add, upsell rows)
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
      try {
        window.subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
          if (ev && ev.source === 'zbs-bundle') return;
          if (ev && (ev.source === 'product-form' || ev.source === 'quick-add')) addedHere = true;
          refreshCartSoon(300);
        });
      } catch (e) {}
    }

    // DOM changes: swatch swap (new .zbs-pdp), cart drawer re-render, facet re-render
    var mo = new MutationObserver(function (muts) {
      var touchedDrawer = false, need = false;
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (nudge && (m.target === nudge || nudge.contains(m.target))) continue;
        need = true;
        if (m.target.closest && m.target.closest('#CartDrawer, cart-drawer')) touchedDrawer = true;
      }
      if (touchedDrawer) refreshCartSoon(250);
      if (need) queueRender();
    });
    mo.observe(document.body, { childList: true, subtree: true });

    // Intelligems assigns the group after load: re-render once it is ready
    var igTries = 0;
    (function waitIg() {
      if (igTiers()) { queueRender(); return; }
      if (++igTries < 60) setTimeout(waitIg, 300);
    })();

    // hide on time even if the tab stays open
    var e = Date.parse(C.end);
    if (e && e > Date.now() && e - Date.now() < 2147483000) setTimeout(render, e - Date.now() + 1000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
